import type { RouteContext } from 'universal-router';
import type { CustomRouteContext, universalRouterProps } from './types';
import type { Store } from 'react-redux';

export async function pageResolver(
  props: universalRouterProps,
  context: RouteContext<CustomRouteContext>,
  resolvePage: (context: RouteContext<CustomRouteContext>, store: Store) => Promise<void>,
  forceCSR = false,
): Promise<void> {
  const { isServer = false, store } = props;
  const { shouldResolveOnServer } = context;

  if (isServer) {
    if (!forceCSR && shouldResolveOnServer) {
      await resolvePage(context, store);
    }
  } else {
    if (forceCSR || !shouldResolveOnServer) {
      resolvePage(context, store);
    }
  }
}
